module.exports = __webpack_public_path__ + "img/decor-movie.e1d7eabf.png";